module.exports = __webpack_public_path__ + "img/s1-icon-3.e0297683.png";